import { DocWithPreview } from '../../Common/DocWithPreview'
import { Box, Grid, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import TextLabel from '../../Common/CommonTextLabel'
import { makeStyles } from 'tss-react/mui';
import { useLocation } from 'react-router';
import { BucketURL } from '../../../ApiSetup/Api';
import CommonTextField from '../../Common/CommonTextField';
import dayjs from 'dayjs'
import CommonTextArea from '../CommonTextArea';
import ButtonOutlined from '../../Common/ButtonOutlined';
import ButtonContained from '../../Common/ButtonContained';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommonDatePicker from '../../Common/CommonDatePicker';
import { Regex } from '../../../Utils/regex';
import { checkAccess, getImageUrl } from '../../../Utils/handler';
import ReUploadModal from '../../Common/ReUploadModal';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import sessionStoreUtil from '../../../ApiSetup/Localstorage';

const useStyles = makeStyles()((theme) => {

    return {
        gridBorder: {
            background: theme.palette.secondary.main,
            border: `2px dashed ${theme.palette.bgLightBlack.main}`,
            padding: "10px", // Default value
            borderRadius: "12px",
        },
    }
})
const AadharCard = ({ data, isEdit, setIsEdit, setImagePreView, handleStatusChange, _updateMember, handleInputChange, setValue, handleUpload, handleFilterChange, handleChange, errors, dataAccess, openFrontSide, setOpenFrontSide, openBackSide, setOpenBackSide }) => {
    const theme = useTheme()
    const { pathname } = useLocation();

    const startPathname = pathname?.split('-')[0];
    const user = sessionStoreUtil.getLSItem("userData") ? JSON.parse(sessionStoreUtil.getLSItem("userData")) : {};

    return (
        <Grid container spacing={2} item xs={12} sm={12}>

            <Grid item xs={12}  >
                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Verify Aadhar Card"} />
            </Grid>

            <Grid item xs={12} sm={6} >
                <Box onClick={() => { setImagePreView({ isOpen: true, link: getImageUrl(Array.isArray(data?.personalDetails?.aadhaarFrontSide) ? data?.personalDetails?.aadhaarFrontSide[0] : data?.personalDetails?.aadhaarFrontSide) }); }}>
                    <DocWithPreview
                        docArray={Array.isArray(data?.personalDetails?.aadhaarFrontSide) 
                            ? data?.personalDetails?.aadhaarFrontSide 
                            : data?.personalDetails?.aadhaarFrontSide 
                                ? [data?.personalDetails?.aadhaarFrontSide] 
                                : []}
                        docName={"Front Side"}
                        title={"Aadhar Card"}
                    />
                    {(checkAccess(startPathname, dataAccess, 'Reupload Button') && isEdit.aadharCard) &&
                        <ButtonOutlined
                            startIcon={<CloudSyncOutlinedIcon fontSize='large' />}
                            width={"auto"}
                            text={"Reupload"}
                            padding={{ xs: "5px 10px", md: "5px 10px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "30px", sm: "30px" }}
                            border={"none"}
                            onClick={() => { setOpenFrontSide(true) }}
                        />}
                </Box>
            </Grid>

            <Grid item xs={12} sm={6} >
                <Box onClick={() => { setImagePreView({ isOpen: true, link: getImageUrl(Array.isArray(data?.personalDetails?.aadhaarBackSide) ? data?.personalDetails?.aadhaarBackSide[0] : data?.personalDetails?.aadhaarBackSide) }); }}>
                    <DocWithPreview
                        docArray={Array.isArray(data?.personalDetails?.aadhaarBackSide) 
                            ? data?.personalDetails?.aadhaarBackSide 
                            : data?.personalDetails?.aadhaarBackSide 
                                ? [data?.personalDetails?.aadhaarBackSide] 
                                : []}
                        docName={"Back Side"}
                        title={"Aadhar Card"}
                    />
                    {(checkAccess(startPathname, dataAccess, 'Reupload Button') && isEdit.aadharCard) &&
                        <ButtonOutlined
                            startIcon={<CloudSyncOutlinedIcon />}
                            border={"none"}
                            width={"auto"}
                            text={"Reupload"}
                            padding={{ xs: "5px 10px", md: "5px 10px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "30px", sm: "30px" }}
                            onClick={() => { setOpenBackSide(true) }}
                        />}
                </Box>
            </Grid>

            <Grid container spacing={1}>

                <Grid item xs={12}>
                    <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>

                        {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                            <Box display={'flex'} alignItems={'center'} gap={1}>
                                <ToggleButtonGroup
                                    color={data?.aadharCard?.status == "Approved" ? "success" : "error"}
                                    value={data?.aadharCard?.status}
                                    exclusive
                                    aria-label="Platform"
                                    size='small'

                                >
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "aadharCard", "Approved")}>
                                        {data?.aadharCard?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                    <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "aadharCard", "Rejected")}>
                                        {data?.aadharCard?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        }
                        {
                            checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                            data?.verificationStatus == "Approved" && <ButtonOutlined
                                width={"auto"}
                                text={"Approved"}
                                border={"1px dashed green"}
                                color={'green'}
                                borderRadius={'20px'}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px", md: "30px" }}
                                endIcon={<CheckCircleIcon />}
                            />}
                    </Box>
                </Grid>

                {data?.verificationStatus !== "Approved" && data?.aadharCard?.status == "Rejected" && <Grid item xs={12}>
                    <CommonTextArea
                        label="Reason"
                        value={data?.aadharCard?.reason}
                        labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                        name='reason'
                        onChange={(e) => handleInputChange(e, "aadharCard")}
                        rows={2}
                        disabled={user?.organisationName !== "PPSK"}
                    />
                </Grid>}

            </Grid>

            {openFrontSide &&
                <ReUploadModal
                    open={openFrontSide}
                    handleClose={() => setOpenFrontSide(false)}
                    onSave={() => setOpenFrontSide(false)}
                    text={"Front Side (આગળની બાજુ)"}
                    name={"frontSide"}
                    onChange={(e) => handleUpload(e, "uploadDocuments", "aadharCard")}
                    imageValue={data?.uploadDocuments?.aadharCard?.frontSide}
                />}

            {openBackSide &&
                <ReUploadModal
                    open={openBackSide}
                    handleClose={() => setOpenBackSide(false)}
                    onSave={() => setOpenBackSide(false)}
                    text={"Back Side (પાછળની બાજુ)"}
                    name={"backSide"}
                    onChange={(e) => handleUpload(e, "uploadDocuments", "aadharCard")}
                    imageValue={data?.uploadDocuments?.aadharCard?.backSide}
                />}

        </Grid >
    )
}

export default AadharCard
